// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".demo[data-v-f6d49e68]{display:flex;justify-content:space-between}.action-card[data-v-f6d49e68]>:last-child{padding:0}", ""]);
// Exports
module.exports = exports;
